/**
 * The Service Invoicing model and the small pure helpers it stands on, in ONE place for the client and (from slice 4c) the
 * server (FIN-D6 4a). Moved here from client/src/lib so the batch-invoice writer can recompute eligibility with the SAME
 * code the screen uses, never a second copy. Pure: no Firebase, no React, no DOM.
 */
export * from './yesNo';
export * from './softDelete';
export * from './timestamp';
export * from './invoiceLifecycle';
export * from './ticketStatuses';
export * from './serviceInvoicingModel';
